import { Loader, Center } from '@mantine/core'

export const PageLoader = () => (
    <Center style={{ height: '50vh' }}>
        <Loader />
    </Center>
)

export const AdminPageLoader = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '50vh',
        fontSize: '1.2rem',
        color: 'var(--mantine-color-blue-6)',
        padding: '2rem'
    }}>
        <Loader />
        <p style={{ marginTop: '1rem' }}>Loading admin interface...</p>
    </div>
)
